import { render } from "./StaffEvaluation.vue?vue&type=template&id=0fa7a868&scoped=true"
import script from "./StaffEvaluation.vue?vue&type=script&lang=js"
export * from "./StaffEvaluation.vue?vue&type=script&lang=js"

import "./StaffEvaluation.vue?vue&type=style&index=0&id=0fa7a868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa7a868"]])

export default __exports__